const { UploadCache } = require('../../storage/upload-cache.js');
const logger = require('../../logger');
const { validateUploadId } = require('../utils/upload-validator');

/**
 * 缓存服务类
 */
class CacheService {
    constructor() {
        // UploadCache 是静态类，不需要实例化
        this.uploadCache = UploadCache;
    }

    async findResumeRecord(teacherId, fileMD5) {
        if (!teacherId || !fileMD5) {
            return null;
        }

        try {
            return await this.uploadCache.findRecord(teacherId, fileMD5);
        } catch (error) {
            logger.info('[CacheService] Failed to find resume record:', error.message);
            return null;
        }
    }

    async saveUploadRecord(record) {
        if (!record.fileMD5) {
            return false;
        }

        try {
            await this.uploadCache.saveRecord(record);
            logger.info('[CacheService] Upload record saved successfully');
            return true;
        } catch (error) {
            logger.info('[CacheService] Failed to save upload record:', error.message);
            return false;
        }
    }

    async updatePartInfo(uploadId, partInfo) {
        if (!uploadId) {
            return false;
        }

        try {
            await this.uploadCache.updatePart(uploadId, partInfo);
            return true;
        } catch (error) {
            logger.info('[CacheService] Failed to update part info:', error.message);
            return false;
        }
    }

    async getUploadRecord(uploadId) {
        if (!uploadId) {
            return null;
        }

        try {
            return await this.uploadCache.getRecord(uploadId);
        } catch (error) {
            logger.info('[CacheService] Failed to get upload record:', error.message);
            return null;
        }
    }

    async deleteUploadRecord(uploadId) {
        if (!uploadId) {
            return false;
        }

        try {
            await this.uploadCache.deleteRecord(uploadId);
            logger.info('[CacheService] Upload record deleted successfully');
            return true;
        } catch (error) {
            logger.info('[CacheService] Failed to delete upload record:', error.message);
            return false;
        }
    }

    async validateUploadIdOnS3(s3Client, bucket, key, uploadId, abortSignal) {
        return await validateUploadId(s3Client, bucket, key, uploadId, abortSignal);
    }
}

module.exports = CacheService;
